
export const GET_CATEGORY_LIST = 'GET_CATEGORY_LIST';
export const GET_SUB_CATEGORY_LIST = 'GET_SUB_CATEGORY_LIST';


export const CREATE_SERVICE_REQUEST = "CREATE_SERVICE_REQUEST";
export const FETCH_CUSTOMER_DETAILS = "FETCH_CUSTOMER_DETAILS";

export const FETCH_SERVICE_REQUEST_DETAILS = "FETCH_SERVICE_REQUEST_DETAILS";

export const FETCH_CUSTOMER_USER_DETAILS = "FETCH_CUSTOMER_USER_DETAILS";
export const FETCH_CUSTOMER_BANK_DETAILS = "FETCH_CUSTOMER_BANK_DETAILS";
export const FETCH_CUSTOMER_BANK_STATEMENTS = "FETCH_CUSTOMER_BANK_STATEMENTS";
export const FETCH_CUSTOMER_SERVICE_REQUESTS = "FETCH_CUSTOMER_SERVICE_REQUESTS";

export const FETCH_SR_STATUS_OPTIONS = "FETCH_SR_STATUS_OPTIONS";
export const UPDATE_SR_STATUS = "UPDATE_SR_STATUS";
export const RESET_ERROR_STATE = "RESET_ERROR_STATE";
export const RESET_CUSTOMER_DATA = "RESET_CUSTOMER_DATA";
export const RESET_SR_DATA = "RESET_SR_DATA";